import GrmSelfieSegmentationWorker from "@/lib/gooroomee/mediapipe/selfie-segmentation/grm-selfieSegmentationWorker";
import GrmSelfieSegmentation from "@/lib/gooroomee/mediapipe/selfie-segmentation/grm-selfieSegmentation";

export default class GrmSelfieSegmentationFactory {
    static create(options) {
        if(options?.worker){
            return new GrmSelfieSegmentationWorker(options);
        }
        return new GrmSelfieSegmentation(options);
    }
}